import styles from './Login.module.css';

/** Ambient orbs + beam — matches member portal visual spec (no floating icon badges). */
export function AuthAmbientBackdrop() {
  return (
    <>
      <div className={`${styles.authOrb} ${styles.authOrb1}`} aria-hidden />
      <div className={`${styles.authOrb} ${styles.authOrb2}`} aria-hidden />
      <div className={`${styles.authOrb} ${styles.authOrb3}`} aria-hidden />
      <div className={styles.authBeam} aria-hidden />
    </>
  );
}
